/* suz-rotator.js — Suztain
   Bytter bilde i en promo-rute paa timer. Delt av Promo grid B og B2.

   Kontrakt i markupen:
     <a class="pgb__card" href="…">              <- lenken som skal folge rammen
       <div data-suz-rot>
         <img class="… suz-rot__f is-on" src="…" data-sek="6"
              data-href="…" data-tittel="…" data-pris="…" data-fpris="…">
         <img class="… suz-rot__f" data-src="…"  data-sek="4"
              data-href="…" data-tittel="…" data-pris="…" data-fpris="…" alt="">
       </div>
       <h3 class="pgb__title">…</h3>
       <span class="pgb__price">…<s>…</s></span>
     </a>

   Ramme 2 og utover har INGEN src, bare data-src. De lastes forst naar
   de skal vises, saa de koster null byte ved sidevisning og kan ikke
   konkurrere med LCP-bildet. Uten dette hadde en rute med tre rammer
   trippelt bildevekten paa forsiden.

   VIKTIG: hver ramme baerer sin egen lenke, tittel og pris. Uten det
   ville en kunde som klikker paa bilde 2 havne paa produktet fra bilde 1.
   Liquid fyller data-attributtene med ramme 1 sine verdier naar rammen
   ikke har eget produkt, saa flere bilder av SAMME produkt fungerer
   fortsatt som for.

   Rotasjonen gaar bare naar ruten er i synsfeltet, og stopper ved hover,
   fokus, skjult fane og prefers-reduced-motion.

   September 2026: prikker nederst paa bildet (en per ramme, kan trykkes)
   og sveip paa beroeringsskjerm. Et manuelt bytte nullstiller timeren.
   Ved redusert bevegelse staar timeren stille, men prikker og sveip
   virker fortsatt - det er kunden selv som velger.
*/
(function(){
  var REDUSERT = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(rot){
    if(rot.__suzRot) return;
    var rammer = Array.prototype.slice.call(rot.querySelectorAll('.suz-rot__f'));
    if(rammer.length < 2) return;
    rot.__suzRot = true;

    var i = 0, timer = null, synlig = false, pauset = false;

    // Kortet er det som pauser paa hover. Lenken er det som skal bytte
    // href. Som regel er det samme element, men i Promo B kan kortet
    // vaere en div uten lenke.
    var kort  = (rot.closest && rot.closest('a, .spg__card, .pgb__card')) || rot;
    var lenke = rot.closest && rot.closest('a');
    var tittelEl = kort.querySelector('.pgb__title, .spg__title');
    var prisEl   = kort.querySelector('.pgb__price, .spg__price');

    function sek(n){
      var v = parseFloat(rammer[n].getAttribute('data-sek'));
      return (v > 0 ? v : 6) * 1000;
    }

    function last(n){
      var f = rammer[n], kilde = f.getAttribute('data-src');
      if(!kilde) return;
      var sett = f.getAttribute('data-srcset');
      if(sett){ f.setAttribute('srcset', sett); f.removeAttribute('data-srcset'); }
      f.src = kilde;
      f.removeAttribute('data-src');
    }

    // Skriver pris som tekstnoder, aldri som HTML. Da kan et produktnavn
    // eller en prisstreng aldri injisere markup i kortet.
    function skrivPris(pris, fpris){
      if(!prisEl) return;
      prisEl.textContent = pris || '';
      if(fpris){
        var s = document.createElement('s');
        s.textContent = fpris;
        prisEl.appendChild(s);
      }
    }

    // Lar resten av kortet folge bildet. Kalles ved hvert bytte.
    function folg(n){
      var f = rammer[n];
      if(lenke && f.hasAttribute('data-href')){
        var h = f.getAttribute('data-href');
        // Tom verdi betyr at rammen ikke har lenke. Da fjernes href helt:
        // en <a> uten href er ikke en lenke og fører ingen steder.
        if(h) lenke.setAttribute('href', h); else lenke.removeAttribute('href');
      }
      var t = f.getAttribute('data-tittel');
      if(tittelEl && t !== null) tittelEl.textContent = t;
      if(f.hasAttribute('data-pris')){
        skrivPris(f.getAttribute('data-pris'), f.getAttribute('data-fpris'));
      }
    }

    // --- Prikker -------------------------------------------------------
    // En prikk per ramme, nederst paa bildet. Bygges her og ikke i Liquid,
    // saa antallet alltid stemmer med rammene som faktisk finnes.
    // <span role="button">, ikke <button>: kortet er ofte en <a>, og
    // interaktivt innhold inne i en lenke er ugyldig HTML.
    var prikker = [];
    var dots = document.createElement('div');
    dots.className = 'suz-rot__dots';
    rammer.forEach(function(_, n){
      var d = document.createElement('span');
      d.className = 'suz-rot__dot' + (n === 0 ? ' is-on' : '');
      d.setAttribute('role', 'button');
      d.setAttribute('tabindex', '0');
      d.setAttribute('aria-label', 'Bilde ' + (n + 1) + ' av ' + rammer.length);
      d.addEventListener('click', function(e){
        e.preventDefault();               // ikke folg kortets lenke
        e.stopPropagation();
        gaa(n);
      });
      d.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); e.stopPropagation(); gaa(n); }
      });
      dots.appendChild(d);
      prikker.push(d);
    });
    kort.appendChild(dots);
    kort.classList.add('suz-rot--dots');

    function merkPrikk(n){
      prikker.forEach(function(d, k){ d.classList.toggle('is-on', k === n); });
    }

    // --- Bytte ---------------------------------------------------------
    function gaa(n){
      n = (n + rammer.length) % rammer.length;
      if(n === i){ plan(); return; }
      last(n);
      last((n + 1) % rammer.length);   // forhandslast den etter, saa byttet aldri blir tomt
      rammer[i].classList.remove('is-on');
      rammer[n].classList.add('is-on');
      folg(n);
      merkPrikk(n);
      i = n;
      plan();                          // manuelt bytte nullstiller klokka
    }
    function neste(){ gaa(i + 1); }

    function stopp(){ if(timer){ clearTimeout(timer); timer = null; } }
    function plan(){
      stopp();
      if(REDUSERT || !synlig || pauset || document.hidden) return;
      timer = setTimeout(neste, sek(i));
    }

    // --- Sveip paa beroeringsskjerm -------------------------------------
    // Vannrett drag bytter ramme; loddrett drag er vanlig scrolling og
    // roeres ikke (touch-action: pan-y i CSS). Et sveip skal ikke ogsaa
    // utloese kortets lenke, derfor stoppes det foelgende klikket.
    var sx = 0, sy = 0, sveipet = false;
    kort.addEventListener('touchstart', function(e){
      if(!e.touches || e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; sveipet = false;
    }, {passive:true});
    kort.addEventListener('touchend', function(e){
      if(!e.changedTouches || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3){
        sveipet = true;
        gaa(dx < 0 ? i + 1 : i - 1);
      }
    }, {passive:true});
    kort.addEventListener('click', function(e){
      if(sveipet){ e.preventDefault(); e.stopPropagation(); sveipet = false; }
    }, true);

    // Hover og fokus pauser. Er kunden borti ruten, skal bildet staa stille
    // - ellers bytter produktet under fingeren idet hun klikker.
    ['mouseenter','focusin'].forEach(function(e){
      kort.addEventListener(e, function(){ pauset = true; stopp(); }, {passive:true});
    });
    ['mouseleave','focusout'].forEach(function(e){
      kort.addEventListener(e, function(){ pauset = false; plan(); });
    });
    document.addEventListener('visibilitychange', plan);

    if('IntersectionObserver' in window){
      new IntersectionObserver(function(poster){
        synlig = poster[0].isIntersecting;
        if(synlig) last((i + 1) % rammer.length);   // gjor neste ramme klar litt for tid
        plan();
      }, {rootMargin:'200px'}).observe(rot);
    } else {
      synlig = true;
      plan();
    }
  }

  function boot(rot){
    (rot || document).querySelectorAll('[data-suz-rot]').forEach(init);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();
